
import store from '../../config/store'

export default {

  components: {
    EditMultipleTransfer: () => import(/* webpackChunkName: "transfers" */ '@/common/pages/Transfers/EditMultipleTransfer.vue')
  },

  data: () => ({
    store,
    transfersImported: false
  }),

  mounted () {
    this.$bus.$on('validate-multiple-transfer-file', this.onValidateMultipleTransferFile)
  },

  destroyed () {
    this.$bus.$off('validate-multiple-transfer-file', this.onValidateMultipleTransferFile)
  },

  methods: {

    onAttachFiles () {
      this.showModal({
        childVue: 'join-transfer-documents',
        wrapperClass: 'modal modal--md',
        dataModel: {
          isLocal: true,
          multipleFiles: false
        }
      })
    },

    onValidateMultipleTransferFile () {
      this.transfersImported = true
    },

    downloadCsv () {
      window.open('https://lbostatic.blob.core.windows.net/docs/csv/model_multiple_transfers.csv')
    }
  }

}
